import { appendModelingControlParams } from "./request_params";

const SAVE_ERROR_MESSAGE = "Could not save your modeling changes. Please try again.";

export async function saveModelingControls(saveUrl) {
  const params = new URLSearchParams();
  appendModelingControlParams(params);

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

  let response;
  try {
    response = await fetch(saveUrl, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        "X-Requested-With": "XMLHttpRequest",
      },
      body: params.toString(),
    });
  } catch (_error) {
    throw new Error(SAVE_ERROR_MESSAGE);
  }

  if (response.ok) return;

  const data = await response.json().catch(() => ({}));
  const message =
    Array.isArray(data.errors) && data.errors.length > 0 ? data.errors.join(". ") : SAVE_ERROR_MESSAGE;
  throw new Error(message);
}
